import { FilterStore } from './filter-store'


/**
 * Place to store mutable state pertaining to reviews.
 */

/**
 * Interface for the state property inside the store
 */
export interface IReviewsStoreState {
  filterStore: FilterStore
  sort: string
  searchTerm: string
}

export class ReviewsStore {
  constructor() {
    this.state.filterStore = new FilterStore()
  }

  state: IReviewsStoreState = {
    filterStore: undefined,
    sort: undefined,
    searchTerm: ''
  }

  get filterStore(): FilterStore {
    return this.state.filterStore
  }

  set sort(sort: string) {
    this.state.sort = sort
  }

  get sort(): string {
    return this.state.sort
  }

  set searchTerm(searchTerm: string) {
    this.state.searchTerm = searchTerm
  }

  get searchTerm(): string {
    return this.state.searchTerm
  }
}

export default new ReviewsStore()



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/store/reviews-store.ts